const getEnvironmentFromUrl = () => {
  const hostname = window.location.hostname;

  switch (hostname) {
    case 'chime.com':
    case 'www.chime.com':
    case 'chime-com.chime.com':
    case 'enterprise.chime.com':
      return 'production';
    case 'localhost':
      return 'local';
    default:
      // Extract environment from subdomain (e.g., chime-com-dev1.chime.com -> dev1)
      const match = hostname.match(/^(chime-com|enterprise)-([^.]+)\.chime\.com$/);
      return match ? match[2] : 'development';
  }
};

export const appEnvironment =
  typeof window === 'undefined'
    ? process.env.ENV || process.env.NODE_ENV // Server-side
    : getEnvironmentFromUrl(); // Client-side

export const isLocalEnvironment = () => appEnvironment === 'local';
export const isQAEnvironment = () => appEnvironment === 'qa'; // used only for data dog RUM collection in QA
export const isProdEnvironment = () => appEnvironment === 'production';
export const isCypressTesting = () => {
  // Server-side: check environment variable
  if (typeof window === 'undefined') {
    // process.env.CYPRESS is set when the NextJS server is started by `yarn dev:cypress`
    return process.env.CYPRESS === 'true';
  }
  // Client-side: check window.Cypress
  return !!window.Cypress;
};
